module.exports = __webpack_public_path__ + "b2fed478e9fc5c8ffbaaa9f6f41513c6.png";